"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nConfig = exports.DEFAULT_ROOT_LOCALE = void 0;
const enums_1 = require("@finbackoffice/enums");
exports.DEFAULT_ROOT_LOCALE = "default";
exports.i18nConfig = {
    defaultLocale: exports.DEFAULT_ROOT_LOCALE,
    locales: [
        exports.DEFAULT_ROOT_LOCALE,
        enums_1.Language.en,
        enums_1.Language.ko,
        enums_1.Language.ru,
        enums_1.Language.tr,
        enums_1.Language.ja,
        enums_1.Language.de,
        enums_1.Language.es,
        enums_1.Language.pt,
        enums_1.Language.ro,
        enums_1.Language.sw,
    ],
    localeDetection: false,
};
//# sourceMappingURL=i18n.config.js.map